import { type CanvasElement } from '@blaze-runtime/engine-domain';
/** Creates an array with the provided namespace and all namespaces hosted inside of it */
export function findRelatedNamespaces(elements: CanvasElement[], rootNamespace: string): string[] {
  const namespaces = new Set<string>();

  const visitNamespace = (namespace: string): void => {
    namespaces.add(namespace);

    elements.forEach((element) => {
      // For every element in the namespace
      if (element.ns === namespace) {
        // Visit hosted namespaces
        element.slots?.ids?.forEach((id) => {
          const hostedNamespace = element?.slots?.[id]?.hosting?.ns;
          if (hostedNamespace) {
            visitNamespace(hostedNamespace);
          }
        });
      }
    });
  };

  visitNamespace(rootNamespace);

  return [...namespaces];
}
